import { render, staticRenderFns } from "./SubmissionGeneralReport.vue?vue&type=template&id=38776c60"
import script from "./SubmissionGeneralReport.vue?vue&type=script&lang=js"
export * from "./SubmissionGeneralReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports